import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Button, Form } from 'react-bootstrap';
import './SignUp.css';

const SignUp = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        termsAccepted: false
    });
    const [showPassword, setShowPassword] = useState(false);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const togglePassword = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (formData.password.length < 8) {
            alert('Password must be at least 8 characters long!');
            return;
        }

        if (!formData.termsAccepted) {
            alert('Please accept the Terms of Service and Privacy Policy!');
            return;
        }

        // Here you would typically send the data to your backend
        console.log('Form submitted:', formData);
        alert('Account created successfully!');
    };

    const handleGoogleSignUp = () => {
        // Handle Google sign up logic here
        console.log('Google sign up clicked');
    };

    return (
        <div className="common-container d-flex justify-content-center align-items-center p-3 overflow-hidden fw-regular">
            <div className="common-card overflow-hidden my-0 mx-auto d-flex flex-column">
                {/* Header */}
                <div className="common-header text-center position-relative">
                    <div className="logo mb-1 fw-bold">
                        <i className="fas fa-rocket" style={{ marginRight: '0.5rem' }}></i>
                        ProjectFlow
                    </div>
                    <div className="logo-subtitle fw-regular">Streamline Your Projects</div>
                </div>
                {/* Body */}
                <div className="common-body d-flex flex-column">
                    <h1 className="common-title fw-bold mb-3 text-center">Create Your Account</h1>
                    <button className="btn-google" onClick={handleGoogleSignUp}> <i className="fab fa-google"></i> Sign Up with Google </button>
                    <div className="divider text-center my-3 position-relative z-0">
                        <span className='bg-white px-3 fw-medium'>OR</span>
                    </div>
                    <Form onSubmit={handleSubmit}>
                        <Row className="g-3 mb-4">
                            <Col lg={6}>
                                <Form.Group controlId="firstName">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="firstName"
                                        placeholder="First name"
                                        value={formData.firstName}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col lg={6}>
                                <Form.Group controlId="lastName">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="lastName"
                                        placeholder="Last name"
                                        value={formData.lastName}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group controlId="email">
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        placeholder="Enter your email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group controlId="password">
                                    <Form.Label>Password</Form.Label>
                                    <div className="password-field d-flex position-relative">
                                        <Form.Control
                                            type={showPassword ? 'text' : 'password'}
                                            name="password"
                                            placeholder="Create password"
                                            value={formData.password}
                                            onChange={handleInputChange}
                                            required
                                        />
                                        <Button
                                            variant="outline-secondary"
                                            className="password-toggle ms-2 bg-transparent"
                                            onClick={togglePassword}
                                            aria-label="Toggle password visibility"
                                            tabIndex={-1}
                                        >
                                            <i className={`fas ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                                        </Button>
                                    </div>
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Form.Group controlId="termsCheck">
                                    <Form.Check
                                        type="checkbox"
                                        name="termsAccepted"
                                        label={
                                            <>
                                                I agree to the <Link to="/terms" className="terms-link fw-semibold text-decoration-none btn btn-link" style={{ textDecoration: 'none' }}>Terms of Service</Link> and <Link to="/privacy" className="terms-link fw-semibold text-decoration-none btn btn-link" style={{ textDecoration: 'none' }}>Privacy Policy</Link>
                                            </>
                                        }
                                        checked={formData.termsAccepted}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col sm={12}>
                                <Button type="submit" variant="primary" className="w-100">
                                    Create Account
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                    <div className="d-flex align-items-center justify-content-center">
                        Already have an account?{' '}
                        <Button variant="link" className="p-0 text-decoration-none ms-1" as={Link} to="/login">
                            Sign In
                        </Button>
                    </div>
                </div>
            </div>
        </div>);
};

export default SignUp;
